module.exports = __webpack_public_path__ + "static/Favor-3501a3bf5c8719db483ff17211655d2b.jpg";